import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable()
export class OrgApiDataService {
   url = environment.url;

   constructor(private http: HttpClient){}

   //LIST
   public getOrgList(payload: any): Observable<any> {
      //return this.http.post("./json/orgList.json", payload)
    return this.http.post(`${this.url}get/threeplV2`, payload);
   }

   //UPDATE 
   public updateOrg(payload: any): Observable<any> {
      return this.http.post(`${this.url}update/threeplV2`, payload);
   }

   //MASTER DATA
   public getMasterData(): Observable<any> {
      return this.http.get(`${this.url}masterdata`);
   }

   //AUDIT LOG
   public getAuditLog(): Observable<any> {
      return this.http.get(`${this.url}threePlAuditLog`);
   }

   //DOWNLOAD AUDIT LOG
   public downloadAudit(payload: any): Observable<any> {
    return this.http.post(`${this.url}downloadthreePlAuditLog`, payload);
   }
}